$(document).ready(function() {
  $(".icon.icon-chevron-small.select-wrapper--icon").attr('aria-hidden', 'true');
 
  $('#more-payment-options-link').attr('tabindex', '0');
  $('.header__icon-touch, button.quick-cart__footer-order-note-trigger').click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  });
  $(document).on('click', function() {
    // Remove 'active' class and set aria-expanded to false when clicking outside
    $('.header__icon-touch').removeClass('active').attr('aria-expanded', 'false');
  });

    $(".media-with-content__content").each(function() {
        var headingTitle = $(this).find("h2.section-blocks__heading").text().trim();
        var linkTitle = $(this).find(".section-blocks__button a").text().trim();
        $(this).find(".section-blocks__button a").attr("aria-label", linkTitle + " : " + headingTitle);
    });
    $('br').attr('aria-hidden','true');
    $('hr').attr('aria-hidden','true');
      $('a[href^="mailto:"]').each(function () {
          var email = $(this).attr('href').replace('mailto:', '');
          var ariaLabel = 'Email us: ' + email + '(opens in a new window)';
          
          $(this).attr('aria-label', ariaLabel);
      });
      $('a[href^="tel:+"]').each(function () {
        var number = $(this).attr('href').replace('tel:+', ''); 
        var ariaLabel = 'Tell us: ' + number + '(opens in a new window)';
        
        $(this).attr('aria-label', ariaLabel);
    });
    function updateAriaLabels() {

        $('.product__color-swatches button.dynamic-variant-button').each(function () {
          var $button = $(this);
          var ariaLabel = $button.attr('aria-label');
          
          if ($button.hasClass('selected')) {
            if (!ariaLabel.includes('checked')) {
              $button.attr('aria-label', ariaLabel + ' checked');
            }
          } else {

            $button.attr('aria-label', ariaLabel.replace(' checked', ''));
          }
        });
      }
    
      updateAriaLabels();
    
      $('.product__color-swatches button.dynamic-variant-button').on('click', function () {
        $('.product__color-swatches button.dynamic-variant-button').removeClass('selected');
        $(this).addClass('selected');
        
        updateAriaLabels();
      });

      function updateAriaLabels2() {

        $('.product__color-chips button.dynamic-variant-button').each(function () {
          var $button = $(this);
          var ariaLabel = $button.attr('aria-label');
          
          if ($button.hasClass('selected')) {
            if (!ariaLabel.includes('checked')) {
              $button.attr('aria-label', ariaLabel + ' checked');
            }
          } else {

            $button.attr('aria-label', ariaLabel.replace(' checked', ''));
          }
        });
      }
    
      updateAriaLabels2();
    
      $('.product__color-chips button.dynamic-variant-button').on('click', function () {
        $('.product__color-chips button.dynamic-variant-button').removeClass('selected');
        $(this).addClass('selected');
        
        updateAriaLabels2();
      });
      $('.template-page .rich-text__inner h2.section-blocks__heading').each(function() {
        var $h2 = $(this); 
        var innerHTML = $h2.html();
        var $h1 = $('<h1></h1>').html(innerHTML).addClass($h2.attr('class'));
        $h2.replaceWith($h1);
    });
    $(".testimonials").each(function() {
      var headingTitle = $(this).find("h2.section-header__heading").text().trim();
      $(this).find(".scroll-slider").attr("aria-label", headingTitle + ' Carousel ');
      $(this).find(".scroll-slider").attr("role", "region");
  });
    
      let lastFocusedButton;

    $(".product-item__quick-view-button").on("click", function () {
      lastFocusedButton = $(this);

      setTimeout(function () {
          $(".quick-product__left").attr("tabindex", 0).focus();
      }, 800);
    });

    $(".quick-product-modal__close").on("click", function () {

      if (lastFocusedButton) {
          lastFocusedButton.focus();
      }
      });

    let lastFocusedAdd;

  $(".product-item__quick-add").on("click", function () {
    lastFocusedAdd = $(this);

    setTimeout(function () {
        $(".quick-product__right").attr("tabindex", 0).focus();
    }, 800);
   });

   $(".quick-product-modal__close").on("click", function () {

    if (lastFocusedAdd) {
        lastFocusedAdd.focus();
    }
    });
// carousel jquery start

// function updateAriaHidden() {
//   $('.testimonial-item-wrapper').each(function() {
//       var $slide = $(this);
//       if (isElementInViewport($slide)) {
//           $slide.attr('aria-hidden', 'false');
//       } else {
//           $slide.attr('aria-hidden', 'true');
//       }
//   });
// }

// function isElementInViewport(el) {
//   var rect = el[0].getBoundingClientRect();
//   var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
//   var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

//   return (
//       rect.top >= 0 &&
//       rect.left >= 0 &&
//       rect.bottom <= viewportHeight &&
//       rect.right <= viewportWidth
//   );
// }

// updateAriaHidden();

// $('.scroll-slider__slider').on('scroll', function() {
//   updateAriaHidden();
// });

// $(window).on('resize', function() {
//   updateAriaHidden();
// });
// carousel jquery end

});

// ecomback60's work

// cart drawer focus
$(document).ready(function() {
  // Close button fopcus
  document.querySelector('.quick-cart__close-icon').addEventListener('click', function() {
    const searchButton = document.querySelector('.header__cart-link');
    const searchDrawer = document.querySelector('.quick-cart__wrapper');
    if (searchDrawer) {
        searchDrawer.classList.remove('active'); // Remove the active class
    }
    if (searchButton) {
        searchButton.focus(); 
    }
  });

// close on escape 
  document.addEventListener('keydown', function(event) {
    const searchDrawer = document.querySelector('.quick-cart__wrapper');
    if (event.key === 'Escape' && searchDrawer.classList.contains('active')) {
        searchDrawer.classList.remove('active'); // Remove the active class
        const searchButton = document.querySelector('.header__cart-link');
        if (searchButton) {
            searchButton.focus();
        }
    }
  });
});

//login account popup
$(document).ready(function() {
  $(document).on('focusout', '.header__account-quick-view.active', function(event) {
    const $quickView = $(this);
    const $iconTouch = $('.header__icon-touch.header__icon-touch--account.active');
    
    // Delay to ensure focus change is captured
    setTimeout(function() {
      if (!$quickView.is(':focus-within')) {
        $quickView.removeClass('active').attr('aria-hidden', 'true'); // Remove active and set aria-hidden
        $iconTouch.removeClass('active').attr('aria-expanded', 'false'); // Remove active and set aria-expanded to false
      }
    }, 0);
  });
});

// phone warnings 
$(document).ready(function() {
  $('a[href="tel:+18437796622"],a[href="tel:+17815819394"]').each(function() {
      var originalTitle = $(this).text();
      
      var trimmedTitle = originalTitle.length > 20 ? originalTitle.substring(0, 100) + '' : originalTitle;
      
      // Add "email address" before the trimmedTitle in the aria-label
      $(this).attr('aria-label', 'Phone Number: ' + trimmedTitle + ' (open in a new window)');
      
      $(this).attr('target', '_blank');
      $(this).removeAttr('title');
  });
});

//anchor issue accessible content
$(document).ready(function($) {
  $('a.collection-item__link').each(function() {
      var altText = $(this).find('.collection-item__image__wrap .image.collection-item__image img').attr('alt');
      if (altText) {
          altText = altText.trim();
          $(this).attr('aria-label', altText);
      }
  });
});

$(document).ready(function() {
  $('#accordion-content-description table').attr('role', 'presentation');
});

$(document).ready(function () {
  // Select the <h2> element inside the button
  const $heading = $('#description .accordion__label h2');

  if ($heading.length) {
    // Replace the <h2> tag with <p>, keeping its content and attributes
    $heading.replaceWith(function () {
      return $('<p>', { class: $(this).attr('class') }).append($(this).contents());
    });
  }
});

// blogs link warning
$(document).ready(function () {
  $('.social-share__copy-url').on('click', function () {
    const $message = $('.social-share__success-message.social-share__success-message--hidden');
    const $srOnly = $('.sr-only');
    $srOnly.text('Link copied');
  });
});

// collection add to cart
$(document).ready(function () {
  $('.product-item__quick-add').on('click', function () {
    const feedback = $('#cart-feedback');
    feedback.text('Item added to cart');
    setTimeout(function () {
      feedback.text('');
    }, 400);
  });
});

$(document).ready(function() {
  $('a[href="https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore"]').each(function() {
      var originalTitle = $(this).text();
   

var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
    
    // Add "email address" before the trimmedTitle in the aria-label
    $(this).attr('aria-label', trimmedTitle + ' (open in a new window)');
    
    $(this).attr('target', '_blank');
    $(this).removeAttr('title');});
});